export default __webpack_public_path__ + "static/media/CY.15ac3fb6.svg";